import React, { useContext, useState } from "react"
import styled from "@emotion/styled"
import { css } from "@emotion/react"
import { AppContext } from "src/state/AppState"

import Button from "src/components/Button"
import { trackEvent } from "src/utils/mixpanel"
import { EventName } from "src/utils/eventNames"
import ScrollListener from "src/components/ScrollListener"
import { baseBorderRadius, uiElementSizes } from "src/styles/globals"

import { animations } from "src/styles"
const Container = styled.div`
  position: fixed;
  left: var(--site-margins);
  bottom: 0;
  z-index: 4;
  display: flex;
  gap: 4px;
  align-items: center;
  transition: transform ${animations.mediumSpeed} ease-in-out;
  ${({ hidden }) =>
    hidden
      ? `transform: translateY(${uiElementSizes.large + 5}px)`
      : `translateY(0)`}
`

const NewsletterButton = () => {
  // TODO, show / hide on scroll logic
  // TODO, add dismiss button
  const { toggleModal } = useContext(AppContext)

  const [dismissed, setDismissed] = useState(false)

  const isGuidePageMobile =
    typeof window !== "undefined" &&
    window.location.pathname.includes("/guide") &&
    window.innerWidth <= 1023

  // On the mobile homepage the app-download bar (AppDownloadCallout) owns the
  // bottom of the screen, so the newsletter pill yields to it. Desktop keeps
  // both — they sit in opposite corners and don't overlap.
  const isHomeMobile =
    typeof window !== "undefined" &&
    window.location.pathname === "/" &&
    window.innerWidth <= 1023

  if (dismissed || isGuidePageMobile || isHomeMobile) {
    return null
  }

  return (
    <ScrollListener.Consumer>
      {({ scrolledToTop, scrolledUp }) => {
        const hidden = scrolledToTop || scrolledUp
        return (
          <Container hidden={hidden}>
            <Button
              onClick={() => {
                trackEvent(EventName.HomeNewsletterSubscribeClicked)
                toggleModal("newsletter-modal")
              }}
              css={css`
                border-radius: ${baseBorderRadius}px ${baseBorderRadius}px 0 0;
              `}
            >
              Get our Newsletter
            </Button>
            <Button
              icon="close"
              onClick={() => {
                trackEvent(EventName.NewsletterCtaDismissed)
                setDismissed(true)
              }}
              setTheme="beige"
              shape="circle"
              size="tiny"
              className="close-button"
              css={css`
                position: absolute;
                top: -12px;
                right: -12px;
                z-index: 2;
              `}
            />
          </Container>
        )
      }}
    </ScrollListener.Consumer>
  )
}

export default NewsletterButton
